<div
  class="dropdown global-transition"
  [ngClass]="{
        'dropdown-active': sortDropdownActive,
        'alternative' : alternativeLook,
        'circle': mobileMode && mobileTemplate === 'circle'
    }"
  (clickOutside)="closeDropdown()"
  appClickOutsideComponent>
  <button
    (click)="dropdownMenu()"
    type="button"
    class="btn select-button"
    [disabled]="disabled"
    [ngClass]="{
            'bigger-button': biggerButtonStyle,
            'grey-background': sortDropdownClass === 'greyBackground',
            'white-background': sortDropdownClass === 'whiteBackground',
            'mobile-view': mobileMode
        }">
    <div class="d-flex align-items-center sort-icon">
      <nb-icon
        *ngIf="choosenSortValue?.orderType === 'asc' || choosenSortValue?.orderType === 'desc'"
        icon="{{ choosenSortValue?.orderType === 'asc' ? 'sort-alt' : 'sort' }}"
        pack="icomoon"
        class="sort-icon"></nb-icon>
      <nb-icon
        *ngIf="choosenSortValue?.icon"
        icon="{{ choosenSortValue?.icon }}"
        pack="icomoon"
        [ngClass]="{'only-numbers-visible': onlyNumbers}"
        class="sort-icon"></nb-icon>
      <div class="flag-icon-wrapper" *ngIf="choosenSortValue?.imgSrc">
        <img [src]="choosenSortValue?.imgSrc" class="flag-icon" alt="flag" />
      </div>
      <div class="chosen-value">
        {{ choosenSortValue?.icon || choosenSortValue?.imgSrc ? (choosenSortValue?.name ?? '' | translate | titlecase) : ('view_translations.' +
        choosenSortValue?.name | translate| titlecase) }}
        <span *ngIf="choosenSortValue?.additional"> {{ ': ' + ('view_translations.' + choosenSortValue?.additional | translate | lowercase)}} </span>
      </div>
    </div>
    <div
      *ngIf="tolltipPresent"
      class="tooltip-button tool-tip"
      ngbTooltip="{{ 'sort_rules' | t }}"
      container="body"
      placement="top-right"
      tooltipClass="my-configurations-tooltip">
      <nb-icon icon="info" pack="icomoon"></nb-icon>
    </div>
    <nb-icon *ngIf="!disabled" icon="chevron-down" pack="icomoon" class="chevron-icon"></nb-icon>
  </button>
  <ul class="dropdown-content">
    <ng-container *ngIf="search">
      <div class="p-2">
        <app-search-input class="add-lide-link-modal-search-input" (inputValue)="inputHandler($event)" [placeholder]="'search'"> </app-search-input>
      </div>
    </ng-container>
    <li
      *ngFor="let sortValue of filteredValues || sortValues"
      class="dropdown-item global-transition"
      [ngClass]="{'active' : choosenSortValue?.id === sortValue.id}"
      (click)="getSortValue(sortValue)">
      <!-- <nb-icon icon="{{ sortValue?.icon }}" pack="icomoon" class="list-icon"></nb-icon> -->
      <div class="flag-icon-wrapper" *ngIf="sortValue.imgSrc">
        <img [src]="sortValue.imgSrc" class="flag-icon" alt="flag" />
      </div>
      {{ sortValue.icon || sortValue.imgSrc ? (sortValue?.name ?? '' | translate | titlecase) : 'view_translations.' + sortValue?.name | translate | titlecase
      }}
      <span *ngIf="sortValue?.additional"> {{': ' + ('view_translations.' + sortValue?.additional | translate | lowercase)}} </span>
      <nb-icon *ngIf="sortValue.id === choosenSortValue?.id" icon="check-circle" pack="icomoon" class="check-icon"></nb-icon>
    </li>
  </ul>
</div>
